import React, { useState, useEffect } from "react";
import "./Countdown.css";
import timer  from '../../assets/images/timer.png'

const COUNTDOWN_TARGET = new Date("2024-06-30T23:59:59");

const getTimeLeft = () => {
	const totalTimeLeft = COUNTDOWN_TARGET - new Date();
	const days = Math.floor(totalTimeLeft / (1000 * 60 * 60 * 24));
	const hours = Math.floor((totalTimeLeft / (1000 * 60 * 60)) % 24);
	const minutes = Math.floor((totalTimeLeft / (1000 * 60)) % 60);
	const seconds = Math.floor((totalTimeLeft / 1000) % 60);
	return { days, hours, minutes, seconds };
};

const Countdown = () => {
	const [timeLeft, setTimeLeft] = useState(() => getTimeLeft());

	useEffect(() => {
		const timer = setInterval(() => {
			setTimeLeft(getTimeLeft());
		}, 1000);

		return () => {
			clearInterval(timer);
		};
	}, []);

	return (
		<div className='countdown'>
			<div className="countdownSec">
				<div><img src={timer} alt="Verizon timer" className="count-timer"/> </div>
				<div><strong>Last Chance: Get 6 Months on us when you purchase either our 200 Mbps or 1 Gig plans in Fios Business Internet Service.</strong><br/>
				Offer ends in: {Object.entries(timeLeft).map((el) => {
						const label = el[0];
						const value = el[1];
						return (
							<span className="box">{value} {label}</span>
						);
					})}
				</div>
			</div>
		</div>
	);
};

export default Countdown;